import React from 'react';

const translation = {
  front: { short: 'Fr', long: 'Front' },
  back: { short: 'Ba', long: 'Back' },
  reverse: { short: 'Re', long: 'Reverse' },
  armstand: { short: 'As', long: 'Armstand' },
  inward: { short: 'Iw', long: 'Inward' },
  flying: { short: 'Fly', long: 'Flying' },
  somersaults: { short: 'Ss', long: 'Somersault' },
  twists: { short: 'Tw', long: 'Twist' }
};

const BottomLine = ({ stations }) => {
  if (!stations) return <></>;

  const sortetStations = stations
    .sort((a, b) =>
      a.hasOwnProperty('order') && b.hasOwnProperty('order')
        ? a.order > b.order
          ? 1
          : -1
        : !a.hasOwnProperty('order')
        ? 0
        : !b.hasOwnProperty('order')
        ? -1
        : 0
    )
    .filter(
      (station) =>
        !station.hasOwnProperty('value') ||
        (station.hasOwnProperty('value') &&
          station.value !== 'false' &&
          station.value !== false &&
          parseFloat(station.value) !== 0)
    );

  const getShort = (station) => {
    if (station.type === 'take_off') {
      return translation[station.position] ? translation[station.position].short : '';
    }
    if (station.type === 'flying') {
      return translation[station.type] ? translation[station.type].short : '';
    }
    return `${parseFloat(station.value)}x ${
      translation[station.type] ? translation[station.type].short : ''
    }`;
  };

  const getShortLine = () => {
    let line = '';

    for (let i = 0; i < sortetStations.length; i++) {
      line += `${getShort(sortetStations[i])}${
        i + 1 === sortetStations.length ? '' : ', '
      }`;
    }

    return line;
  };

  return <>{getShortLine()}</>;
};

export { BottomLine, translation };
